import { render } from "./menu-left.vue?vue&type=template&id=50975c56"
import script from "./menu-left.vue?vue&type=script&lang=js"
export * from "./menu-left.vue?vue&type=script&lang=js"

import "./menu-left.vue?vue&type=style&index=0&id=50975c56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__